import {
	ElButton,
	ElCarousel,
	ElCarouselItem,
	ElDivider,
	ElForm,
	ElIcon,
	ElInput,
	ElLoading,
	ElMessage,
	ElNotification,
	ElOption,
	ElProgress,
	ElScrollbar,
	ElSelect,
	FormRules,
	isNotEmpty,
	useForm,
} from '@qsxy/element-plus-react';
import { register, sendVerificationCode } from './api';
import { useNavigate } from 'react-router-dom';
import { Iuser } from '@/typings';
import { useMount } from 'ahooks';
import { appIntro, appName, loginSlogon, sendFreuence } from '@/config';
import { memo, useCallback, useMemo, useRef, useState } from 'react';
import './index.scss';
import { useDispatch } from 'react-redux';
import usePasswordForce from '../settings/usePasswordForce';
import { MOBILE_PATTERN } from '@/components/validatePatterns';
import { WeakPassword } from '../settings/passwordUtil';
import { getTime, setTime } from '@/auth/authUtil';
import HiddenFormItem from '@/components/HiddenFormItem';

enum ForceMap {
	high = 100,
	middle = 65,
	low = 30,
}
enum ForceColorMap {
	high = 'var(--el-color-success)',
	middle = 'var(--el-color-warning)',
	low = 'var(--el-color-error)',
}

const Register = () => {
	const [loading, setLoading] = useState(false);

	const [formInstance] = useForm<Iuser>();

	const PasswordForce = usePasswordForce();
	const navigate = useNavigate();

	const timeOutRef = useRef(sendFreuence);
	const buttonRef = useRef<HTMLSpanElement>(null);

	const [disabled, setDisabled] = useState(false);

	useMount(() => {
		const time = getTime() || sendFreuence;
		timeOutRef.current = Number(time);
		if (timeOutRef.current != sendFreuence) {
			startTimeout();
		}
		const shareFrom = sessionStorage.getItem('shareFrom');
		if (shareFrom) {
			formInstance.setFieldValue('from', shareFrom);
		}
		const ele = document.getElementById('loading');
		if (ele) {
			ele.parentNode.removeChild(ele);
		}
	});

	const startTimeout = () => {
		setDisabled(true);
		buttonRef.current.innerText = timeOutRef.current + 's';
		setTime(timeOutRef.current);
		const stop = setInterval(() => {
			timeOutRef.current = timeOutRef.current - 1;
			setTime(timeOutRef.current);
			if (timeOutRef.current <= 0) {
				timeOutRef.current = sendFreuence;
				setTime(sendFreuence);
				clearInterval(stop);
				setDisabled(false);
				buttonRef.current.innerText = '发送验证码';
			} else {
				buttonRef.current.innerText = timeOutRef.current + 's';
			}
		}, 1000);
	};

	const sendCode = () => {
		formInstance.validateFields(['phoneNumber']).then(user => {
			sendVerificationCode({ type: 'phone', identifier: user.phoneNumber })
				.then(msg => {
					ElMessage.success(msg);
					startTimeout();
				})
				.catch(msg => ElMessage.error(msg));
		});
	};

	const rules = useMemo<FormRules>(() => {
		return {
			phoneNumber: [
				{ required: true, message: '请填写手机号' },
				{ len: 11, message: '请填写11位长度手机号' },
				{ pattern: MOBILE_PATTERN, message: '手机号格式不正确' },
			],
			code: [{ required: true, message: '请填写验证码' }],
			email: [
				{ required: true, message: '请填写邮箱' },
				{ type: 'email', message: '邮箱格式不正确' },
			],
			password: [
				{ required: true, message: '请填写密码' },
				{
					validator(_, value) {
						PasswordForce.validate(value);
						const checkResult = WeakPassword(formInstance.getFieldValue('phoneNumber'), value);
						if (checkResult) {
							return Promise.reject(new Error(checkResult));
						}
						return Promise.resolve();
					},
				},
			],
			passwordConfirm: [
				{ required: true, message: '请重复输入新密码' },
				{
					validator: (_, value) => {
						if (value !== formInstance.getFieldValue('password')) {
							return Promise.reject(new Error('您两次输入的密码不一致！'));
						}
						return Promise.resolve();
					},
				},
			],
		};
	}, [PasswordForce, formInstance]);

	const customColorMethod = useCallback(() => {
		if (PasswordForce.force) {
			return ForceColorMap[PasswordForce.force];
		}
		return 'var(--el-color-info)';
	}, [PasswordForce.force]);

	const onRegister = useCallback(() => {
		formInstance.validateFields().then(values => {
			setLoading(true);
			register({ ...values, username: values.phoneNumber, vertionType: '0' })
				.then(() => {
					setLoading(false);
					ElNotification.closeAll();
					ElMessage.success({
						message: '注册成功，即将跳转至登录页面',
						duration: 1500,
						onClose() {
							navigate('/login');
						},
					});
					const shareFrom = sessionStorage.getItem('shareFrom');
					if (shareFrom) {
						sessionStorage.removeItem('shareFrom');
					}
				})
				.catch(({ message }) => {
					if (isNotEmpty(message)) {
						ElMessage.error({ message: message, grouping: true });
					}
					setLoading(false);
				});
		});
	}, [formInstance, navigate]);

	return (
		<ElLoading visible={loading} text="正在注册中，请稍后...">
			<header className="ttn-layout-header">
				<div className="ttn-topbar" style={{ marginLeft: 15 }}>
					<div className="ttn-topbar-left" onClick={() => navigate('/chat')}>
						<div className="ttn-layout-header-logo">{<img src={require('@/assets/images/logo.png')}></img>}</div>
						<div className="ttn-layout-header-logo1">{<img src={require('@/assets/images/logo1.png')}></img>}</div>
						<div className="ttn-layout-header-logo2">{<img src={require('@/assets/images/logo2.png')}></img>}</div>
						{/* <div className="ttn-welcome-text">
							<div>
								{appName}&nbsp;&nbsp;{appIntro}
							</div>
						</div> */}
					</div>
				</div>
			</header>
			<div className="ttn-register-container ttn-register-positon theme-default">
				<ElScrollbar>
					<div className="ttn-register-content">
						<div className="ttn-register-index-left">
							<ElCarousel height="100vh" trigger="click">
								{loginSlogon.map((item, index) => (
									<ElCarouselItem key={index}>
										<img src={require(`@/assets/images/login${index + 1}.webp`)} />
										<div>
											<p className="carousel__product-info">{item}</p>
										</div>
									</ElCarouselItem>
								))}
							</ElCarousel>
						</div>
						<div className="ttn-register-index-main">
							<ElForm<Iuser> labelPosition="top" className="ttn-register-form" form={formInstance} rules={rules} size="large">
								<HiddenFormItem name="from" />

								<ElForm.Item name="phoneNumber" validateTrigger="onBlur">
									<ElInput
										placeholder="输入手机名"
										autoFocus
										prepend={
											<ElSelect disabled value="+86" style={{ width: 100 }}>
												<ElOption value="+86">+86</ElOption>
											</ElSelect>
										}
									/>
								</ElForm.Item>
								<ElForm.Item name="code">
									<ElInput
										placeholder="输入验证码"
										suffix={
											<ElButton type="primary" link disabled={disabled} onClick={sendCode}>
												<span ref={buttonRef}>发送验证码</span>
											</ElButton>
										}
									/>
								</ElForm.Item>
								<ElForm.Item name="password">
									<ElInput type="password" placeholder="请输入密码" prefix={<ElIcon name="unlock-keyhole" />} showPassword />
								</ElForm.Item>
								<ElForm.Item>
									<ElProgress percentage={PasswordForce.force ? ForceMap[PasswordForce.force] : 0} color={customColorMethod} style={{ width: '100%' }}>
										{PasswordForce.force ? <PasswordForce.View color={ForceColorMap[PasswordForce.force]} /> : <span>密码强度</span>}
									</ElProgress>
								</ElForm.Item>
								<ElForm.Item name="passwordConfirm">
									<ElInput placeholder="请重复输入新密码" type="password" showPassword />
								</ElForm.Item>
								<ElForm.Item name="email">
									<ElInput placeholder="请输入邮箱" />
								</ElForm.Item>
								<ElForm.Item pure center className="ttn-register-btn">
									<ElButton type="primary" block onClick={onRegister} loading={loading}>
										注册
									</ElButton>
								</ElForm.Item>
							</ElForm>
							<ElDivider></ElDivider>

							<div className="register-panel__center-footer">
								<ElButton type="primary" link onClick={() => navigate('/login')}>
									已有账号，返回登录
								</ElButton>
							</div>
						</div>
					</div>
				</ElScrollbar>
			</div>
		</ElLoading>
	);
};

export default memo(Register);
